<template>
  <auth-frame
    :title="displayTitle"
    :centered="centerTitle"
    :wide="$route.name === 'Signup'"
    :language-select="hasLanguageSelect"
  >
    <router-view @override-title="onTitleOverride" @center-title="onCenterTitle" />
  </auth-frame>
</template>

<script>
import AuthFrame from '@/ui/components/AuthFrame.vue';

export default {
  name: 'AuthView',
  components: {
    AuthFrame,
  },
  data: () => ({
    pageTitleOverride: null,
    centerTitle: false,
  }),
  computed: {
    // Not on the token pages and not once a step replaced the page title.
    hasLanguageSelect() {
      return [ 'Login', 'Signup', 'ForgottenPassword' ].includes(this.$route.name)
        && this.pageTitleOverride === null;
    },
    displayTitle() {
      if (this.pageTitleOverride !== null) {
        return this.pageTitleOverride;
      }
      return this.pageTitle;
    },
    pageTitle() {
      const { path } = this.$route;
      let page = '';

      path.includes('login') ? (page = this.tr('Log in')) : '';
      path.includes('signup') ? (page = this.tr('Signup')) : '';
      path.includes('forgotten-password')
        ? (page = this.tr('Forgotten password'))
        : '';
      path.includes('password-reset') ? (page = this.tr('Password reset')) : '';
      path.includes('verify-email') ? (page = this.tr('Email Verification')) : '';

      return page;
    },
  },
  watch: {
    '$route.path'() {
      this.pageTitleOverride = null;
      this.centerTitle = false;
    },
  },
  methods: {
    onTitleOverride(title) {
      this.pageTitleOverride = title;
    },
    onCenterTitle() {
      this.centerTitle = true;
    },
  },
};
</script>
